import styled from 'styled-components';
import sprites from '../../assets/svg/sprites.svg';

export const SectionFilterTool = styled.div`
  position: relative;
  padding: 0;
  transition: 0.3s;
`;

export const FinderBar = styled.div`
  background-color: #f2f2f2;
  padding: 20px 0;

  @media (max-width: 991.98px) {
    position: relative;
    padding: 0;

    &:after {
      width: 100%;
      height: 1px;
      background-color: #1b7bdd;
      content: '';
      position: absolute;
      top: 101px;
      left: 0;
    }
  }
`;

export const Bar = styled.div`
  display: flex;
  justify-content: space-between;

  @media (max-width: 991.98px) {
    display: block;
  }
`;

export const FindOpt = styled.div`
  display: flex;
  flex-wrap: wrap;

  @media (max-width: 991.98px) {
    flex-flow: column;
    padding: 2rem 0;
    position: relative;
    height: 16rem;
    animation-name: ${({ clicked }) => (clicked ? 'dropdown' : 'rollup')};
    animation-duration: 600ms;
    animation-timing-function: linear;
    animation-iteration-count: 1;
    animation-fill-mode: forwards;

    @keyframes dropdown {
      0% {
        margin-bottom: -15.875rem;
      }
      100% {
        margin-bottom: 0;
      }
    }

    @keyframes rollup {
      0% {
        margin-bottom: 0;
      }
      100% {
        margin-bottom: -15.875rem;
      }
    }
  }
`;

export const FormGroup = styled.div`
  @media (min-width: 992px) {
    padding: 10px;
    flex-flow: column;
    display: flex;
    justify-content: center;
    margin-bottom: 0;
  }

  &.press_select_button {
    @media (min-width: 992px) {
      width: 20rem;
    }

    .latestnews_option {
      @media (max-width: 991.98px) {
        transform: translate(0px, -100%);
        width: 300px;
      }

      @media (max-width: 767.98px) {
        width: 100%;
      }
    }
  }

  &.filter_button {
    a {
      min-width: 215px;

      @media (max-width: 767.98px) {
        width: 100%;
      }
    }
  }

  label {
    margin-bottom: 0;
    text-transform: uppercase;
    font-size: 14px;
    color: #2a2a2a;
    line-height: 17px;
    &[dir='ltr'] {
      font-family: 'DINMediumAlternate';
      letter-spacing: 1.5px;
    }
  }

  @media (max-width: 991.98px) {
    display: block;
    padding: 10px;
    flex-flow: column;
    justify-content: center;
  }
`;

export const ViewIcon = styled.div`
  position: relative;
  display: flex;
  height: 35px;
  top: 0;
  margin: 15px 0;
  cursor: pointer;
`;

export const ViewIcons = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  cursor: pointer;

  .sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    clip-path: inset(50%);
    border: 0;
  }

  @media (max-width: 991.98px) {
    position: absolute;
    justify-content: center;
    background: #fff;
    top: calc(100% + 10px);
    left: 50%;
    transform: translate(-50%, 0);
  }
  @media (max-width: 767.98px) {
    display: none;
  }

  &.latestnews_gridview {
    @media (max-width: 991.98px) {
      top: calc(100% + 20px);
    }
  }

  .list {
    margin-left: ${({ dir }) => (dir === 'rtl' ? '2.5rem' : '')};
  }

  .grid,
  .list {
    width: 35px;
  }
`;

export const VIconList = styled.div`
  display: flex;
  width: 35px;
  margin-left: 0rem;

  &.active {
    &:after {
      background: url(${sprites}#listicb);
      background-size: 150px;
    }
  }

  &:hover,
  &:focus {
    &:after {
      background: url(${sprites}#listicb);
      background-size: 150px;
    }
  }

  &:after {
    content: '';
    width: 35px;
    height: 35px;
    background: url(${sprites}#listic) no-repeat;
    background-size: 150px;
  }
`;

export const VIconGrid = styled.div`
  display: flex;
  width: 35px;
  margin-left: 1.5rem;

  &.active {
    &:after {
      background: url(${sprites}#gridicb);
      background-size: 150px;
    }
  }

  &:hover,
  &:focus {
    &:after {
      background: url(${sprites}#gridicb);
      background-size: 150px;
    }
  }

  &:after {
    content: '';
    width: 35px;
    height: 35px;
    background: url(${sprites}#gridic) no-repeat;
    background-size: 150px;
  }
`;

export const ShowHide = styled.div`
  padding: 0.5rem 0;
  display: none;
  width: 100%;
  justify-content: center;
  color: #000;
  text-transform: uppercase;
  font-size: 12px;
  transition: 0.3s;
  cursor: pointer;
  font-family: ${({ dir }) => (dir === 'rtl' ? 'GESSTwoDWTCLight,sans-serif ' : '')};
  position: relative;

  @media (max-width: 991.98px) {
    z-index: 2;
    background: #f2f2f2;
    padding: 40px 0;
    display: flex;
  }

  &:after {
    display: inline-block;
    width: 0;
    height: 0;
    margin-top: 3px;
    margin-left: ${({ dir }) => (dir === 'rtl' ? '' : '1.5rem')};
    margin-right: ${({ dir }) => (dir === 'rtl' ? '1.5rem' : '')};
    vertical-align: 0.255em;
    content: '';
    border: solid #000;
    border-width: 0 2px 2px 0;
    padding: 3px;
    transform: rotate(45deg);
    -webkit-transform: rotate(45deg);
    transition: 0.5s;
  }
`;
